import * as angular from 'angular';

"use strict";

angular.module('ManagementModule', [
    'ui.router', 'ngRoute', 'ngAnimate', 'ngSanitize', 'ui.bootstrap', 'ui.bootstrap.modal'
]);

export default 'ManagementModule';
